/* External */
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { List } from 'immutable';

/* Storage */
import { selectSeasonsListByIdsList } from '../storage/seasons';

/* Utils */
import createCachedListSelectorHook from './createCachedListSelectorHook';

function useShowSeasonsSimple(show) {
  const showSeasonsList = show?.seasons;

  const showSeasonsSelector = useMemo(
    () => selectSeasonsListByIdsList(showSeasonsList),
    [showSeasonsList],
  );
  const showSeasons = useSelector(showSeasonsSelector) || List();

  return useMemo(
    () => showSeasons.sort(
      (firstSeason, secondSeason) => firstSeason.seasonNumber - secondSeason.seasonNumber,
    ).filter(
      ({ hasEpisodes }) => hasEpisodes,
    ),
    [showSeasons],
  );
}

const useShowSeasons = createCachedListSelectorHook(useShowSeasonsSimple);

export default useShowSeasons;
